import {
    Image,
    Link, TabPanel, Text, VStack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { ComponentProps } from 'react';
import { NonIdealState } from '@acp/core-ui';
import { brandIcons } from '@acp/core-ui/assets';
import { ReportedFindingsFacets } from '@acp/shared';
import { UrgentReportedFindingsRow } from './urgent-reported-findings-row';
import { useUrgentReportedFindings } from '../../../reported-findings/hooks/use-reported-findings';
import { ReportedFindingsSkeleton } from '../../../reported-findings/components/table';

export function UrgentReportedFindingsTab({
    propertyManagerId,
    ...props
}: {
    propertyManagerId?: string;
} & ComponentProps<typeof TabPanel>) {
    const { data, isLoading } = useUrgentReportedFindings(
        propertyManagerId
    );

    const reportedFindingsUrl = propertyManagerId === undefined
        ? `/action-required/reported-findings?facet=${ReportedFindingsFacets.ComplianceIssues}`
        : `/action-required/reported-findings?facet=${ReportedFindingsFacets.ComplianceIssues}&property-manager=${propertyManagerId}`;

    if (data === undefined || isLoading) {
        return (
            <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4} {...props}>
                <ReportedFindingsSkeleton />
            </TabPanel>
        );
    }

    return (
        <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4} {...props}>
            {data.total > 0 && (
                <Text>
                    Resolve reported findings via available quotation or
                    marking as resolved by a third party.
                </Text>
            )}
            <VStack alignItems="center" justifyContent="center" gap={4}>
                {data.items.map((item) => (
                    <UrgentReportedFindingsRow
                        key={`${item.property.compliancePropertyId}_${item.reportedFindings[0].problemRegister.serviceCode}`}
                        reportedFinding={item}
                    />
                ))}

                {data.total === 0 && (
                    <NonIdealState
                        iconComponent={<Image src={brandIcons.noActiveNotice} />}
                        title="No properties with reported findings"
                        description="You are all up to date!"
                        py={24}
                    />
                )}
            </VStack>
            {(data.total > data.items.length && propertyManagerId === undefined) && (
                <Link as={RouterLink} to={reportedFindingsUrl}>
                    View all properties with urgent reported findings
                </Link>
            )}
        </TabPanel>
    );
}
